/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TopicPolicyIcon extends BaseIcon {
  getChildren = () => [ <path d="M14,21V6h8V21Zm-1-2c-.78-.78-2.31-1.33-3.35-2.06A17.32,17.32,0,0,0,6,15V2a15.35,15.35,0,0,1,4.36,1.55A17.67,17.67,0,0,1,13,5Zm-2,2H3V6H5V17a7.33,7.33,0,0,1,3.29,1.42A19.78,19.78,0,0,1,11,21Z" fill={this.getColor()}/> ]
  getViewBox = () => '0 0 24 24'
}
